import { Navigate } from 'react-router-dom';
import PaymentRedirect from './components/stripe/paymentRedirect';
import PaymentResponse from './components/stripe/paymentResponse';
import StripeComponent from './components/stripe/planPaymentComponent';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import Register from './pages/Register';
import VerifyEmailComponent from './pages/VerifyEmail';
import BillingComponent from './pages/account/billing/billing.component';
import UserAccount from './pages/account/userAccount';
import AppSumoRegisteration from './pages/app-sumo/appSumoRegister.component';
import NoBrand from './pages/brand/noBrand.component';
import Calendar from './pages/calendar/calendar';
import ChangePassword from './pages/changePassword/changePassword';
import Chat from './pages/chat/Chat';
import Draft from './pages/draft/draftComponent';
import GoogleRedirect from './pages/google-signin/googleRedirect.component';
import FacebookRedirect from './pages/integration/facebookRedirect.component';
import IntegrationComponent from './pages/integration/integration.component';
import LinkedInRedirect from './pages/integration/linkedinIntegration/linkedInRedirect.component';
import TikTokRedirect from './pages/integration/tiktokIntegration/tiktokRedirect.component';
import TwitterRedirect from './pages/integration/twitterIntegration/twitterRedirect.component';
import YoutubeRedirect from './pages/integration/youtubeIntegration/youtubeRedirect.component';
import CreateUserFromToken from './pages/invite-users/createUserFromToken.component';
import ManageBrandInfo from './pages/manage-brand/manageBrandInfo.component';
import Approval from './components/approval/approval.component';
import PublicApproval from './components/public-approval/public-approval.component';
import NotificationSetting from './components/notifications/notification-settings.component';
import Branding from './pages/branding/branding.component';
import Dashboard from './pages/dashboard/dashboard.component';
import GoogleMyBusinessRedirect from './pages/integration/google-my-business-integration/google-my-business-redirect';
import ThreadsRedirect from './pages/integration/threads-integration/threads-redirect.component';
import MediaLibrary from './pages/media-library/media-library.component';
import NoPermissionComponent from './pages/no-permission.component';
import ManageOrganization from './pages/organization/manageOrganization.component';
import NoOrganization from './pages/organization/noOrganization.component';
import PaymentPlan from './pages/payment/payment.component';
import PostInfoComponent from './pages/posts/post-info.component';
import PublishedPostComponent from './pages/publishedPosts/publishedPosts.component';
import ResetPassword from './pages/resetPassword/resetPassword';
import WelcomePageComponent from './pages/welcome/welcomePage.component';
import { CommonHelper } from './utils/commonHelper';
import NewPostComponent from './pages/new-post-new/new-post.component';
import PrivateRouteComponent from './privateRoute';
import DisableUserComponent from './pages/user-disable/disableUser.component';
import BillingInfoComponent from './pages/account/billing/billing-info.component';
import PaymentFailureComponent from './components/stripe/payment-failure.component';
import PaymentSuccessComponent from './components/stripe/payment-success.component';
import PinterestRedirect from './pages/integration/pinterestIntegration/pinterestRedirect.component';
import Report from './pages/reports/report.component';
import ScheduledReport from './pages/scheduled-reports/scheduled-reports.component';
import ScheduledReportsView from './pages/reports/scheduled-reports-table/scheduled-reports-table';
import CRMInfoComponent from './pages/crm/crm.info.component';
import ReferAndEarnComponent from './pages/refer-and-earn/refer-and-earn-component';
import AffiliateRegistration from './pages/affiliate-register/affiliateRegister.component';
import Automation from './pages/automation/automation.component';
import OnBoardingComponent from './pages/on-boarding/on-boarding.component';
import AISetUpComponent from './pages/on-boarding/ai-onboarding.component';
import PaymentOnBoardingComponent from './pages/on-boarding/payment-onboarding.component';
import AIImageGeneration from './pages/ai-image-generation/ai-image-generation.component';
import ResellerUserRegistrationComponent from './pages/organization/re-seller/reseller-register.component';
import InstagramRedirect from './pages/integration/instagramRedirect';

import AutoPostScheduler from './pages/auto-post/auto-post.component';
import AutoDmInfoComponent from './pages/auto-dm/autodm.info.component';
import GenerateAPIKeyComponent from './pages/api/generate-api-key.component';
import CouponUpdateComponent from './pages/app-sumo/coupon-update.component';
import CommonNewPostComponent from './pages/new-post-new/common-new-post.component';
import ResellerComponent from './pages/organization/re-seller/re-seller.component';
import CustomReport from './pages/custom-reports/custom-report.component';
import CustomScheduledReport from './pages/scheduled-reports/custom-scheduled-reports.component';
import FacebookCustomRedirect from './pages/integration/facebookCustomRedirect.component';
import LinkedInCustomRedirect from './pages/integration/linkedinCustomRedirect.component';
import YoutubeCustomRedirect from './pages/integration/youtubeCustomRedirect.component';
import PinterestCustomRedirect from './pages/integration/pinterestCustomRedirect.component';
import TiktokCustomRedirect from './pages/integration/tiktokCustomRedirect.component';
import GbusinessCustomRedirect from './pages/integration/gbusinessCustomRedirect.component';
import TwitterCustomRedirect from './pages/integration/twitterCustomRedirect.component';
import AiCommentMessageComponent from './pages/auto-post/ai-message-comments.component';
import GetStartedComponent from './pages/get-started/get-started.component';
import AccountChangePassword from './pages/account/accountChangePassword';
import ProfileDetails from './pages/profile-details/profile-details';
import Account from './pages/account/accountGeneral';
import BrandInfoComponent from './pages/brand/brandInfo.component';
import ManageRoles from './pages/manage-roles/manageRoles.component';
import ManageUsers from './pages/manage-users/manageUsers.component';
import PendingUsers from './pages/users/pendingUsers.component';
import OrgManageBrand from './pages/organization/organizationBrand';
import OrgInfoComponent from './pages/organization/organizationInfo';
import OrgManageUsers from './pages/organization/organizationUsers';
import WhiteLabel from './pages/branding/white-label.component';
import CustomEmail from './pages/branding/custom-email.component';
import BrandingInfo from './pages/branding/branding-info.component';
import WelcomePageForAdTracking from './pages/welcome/welcome-page-for-ad-tracking';
import WelcomePageForLifeTimeUserComponent from './pages/welcome/welcome-page-for-lifetime-user';
import SnapchatRedirect from './pages/integration/snapchatIntegration/snapchatRedirect.component';

const PrivateRoute = () => {
  return [
    {
      path: 'new-post',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <CommonNewPostComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'integration',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.INTEGRATE_PERMISSION}`}>
          <IntegrationComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'published-post',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <PublishedPostComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'report',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <Report />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'custom-report',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <CustomReport />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'crm',
      element: (
        <PrivateRouteComponent
          permissions={`${CommonHelper.PermissionList.READ_POST}`}
        >
          <CRMInfoComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'scheduled-report-view',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <ScheduledReportsView />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'upcoming-post',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <PostInfoComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'draft',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <Draft />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'automation',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <Automation />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'auto-post',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <AutoPostScheduler />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'ai-message',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <AiCommentMessageComponent />
        </PrivateRouteComponent>
      ),
    },

    {
      path: 'calendar',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <Calendar />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'profile',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <Account/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'change-password',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <AccountChangePassword/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'profile-details',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <ProfileDetails/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'billing',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <BillingInfoComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'message',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.MANAGE_SOCIAL_INBOX}`}>
          <Chat />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'auto-dm',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <AutoDmInfoComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-brand',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <BrandInfoComponent/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-roles',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <ManageRoles/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-users',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <ManageUsers/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'pending-users',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <PendingUsers/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-organization',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <OrgInfoComponent/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-org-brands',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <OrgManageBrand/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'manage-org-users',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <OrgManageUsers/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'branding',
      element: (
        <PrivateRouteComponent permissions={CommonHelper.PermissionList.ORG_ADMIN}>
          <BrandingInfo/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'white-label',
      element: (
        <PrivateRouteComponent permissions={CommonHelper.PermissionList.ORG_ADMIN}>
          <WhiteLabel/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'custom-email',
      element: (
        <PrivateRouteComponent permissions={CommonHelper.PermissionList.ORG_ADMIN}>
          <CustomEmail/>
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'media-library',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <MediaLibrary />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'refer-earn',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <ReferAndEarnComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'notification-settings',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <NotificationSetting />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'approval',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <Approval />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'dashboard',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <Dashboard />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'stripe-payment',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <StripeComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'get-started',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.BRAND_ADMIN}`}>
          <GetStartedComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'welcome',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <WelcomePageComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'welcome-lifetime-user',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <WelcomePageForLifeTimeUserComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'welcome-ad-lifetime',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <WelcomePageForAdTracking />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'welcome-ad',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.READ_POST}`}>
          <WelcomePageForAdTracking />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'ai-image-generation',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.PUBLISH_PERMISSION}`}>
          <AIImageGeneration />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'handle-api',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <GenerateAPIKeyComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'handle-reseller',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <ResellerComponent />
        </PrivateRouteComponent>
      ),
    },
    {
      path: 'coupon-update',
      element: (
        <PrivateRouteComponent permissions={`${CommonHelper.PermissionList.ORG_ADMIN}`}>
          <CouponUpdateComponent />
        </PrivateRouteComponent>
      ),
    },
  ];
};

const PublicRoutes = () => {
  return [
    {
      path: 'not-found',
      element: <Page404 />,
    },
    {
      path: 'no-permission',
      element: <NoPermissionComponent />,
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'reset-password',
      element: <ResetPassword />,
    },
    {
      path: 'change-password',
      element: <ChangePassword />,
    },
    {
      path: 'register',
      element: <Register />,
    },
    {
      path: 'coupon-register',
      element: <AppSumoRegisteration />,
    },
    {
      path: 'affiliate-register',
      element: <AffiliateRegistration />,
    },
    {
      path: 'payment-response',
      element: <PaymentResponse />,
    },
    {
      path: '*',
      element: <Navigate to="/login" replace />,
    },
    {
      path: 'verify-user',
      element: <VerifyEmailComponent />,
    },
    {
      path: 'create-invite-user',
      element: <CreateUserFromToken />,
    },
    {
      path: 'no-brand',
      element: <NoBrand />,
    },
    {
      path: 'no-organization',
      element: <NoOrganization />,
    },
    {
      path: 'user-disable',
      element: <DisableUserComponent />,
    },
    // Redirect Routes
    {
      path: 'twitter-redirect',
      element: <TwitterRedirect />,
    },
    {
      path: 'custom/twitter-redirect',
      element: <TwitterCustomRedirect />,
    },
    {
      path: 'facebook-redirect',
      element: <FacebookRedirect />,
    },
    {
      path: 'custom/facebook-redirect',
      element: <FacebookCustomRedirect />,
    },
    {
      path: 'custom/linkedin-redirect',
      element: <LinkedInCustomRedirect />,
    },
    {
      path: 'custom/pinterest-redirect',
      element: <PinterestCustomRedirect />,
    },
    {
      path: 'custom/youtube-redirect',
      element: <YoutubeCustomRedirect />,
    },
    {
      path: 'custom/tiktok-redirect',
      element: <TiktokCustomRedirect />,
    },
    {
      path: 'custom/gbusiness-redirect',
      element: <GbusinessCustomRedirect />,
    },
    {
      path: 'youtube-redirect',
      element: <YoutubeRedirect />,
    },
    {
      path: 'snapchat-redirect',
      element: <SnapchatRedirect/>,
    },
    {
      path: 'gbusiness-redirect',
      element: <GoogleMyBusinessRedirect />,
    },
    {
      path: 'linkedin-redirect',
      element: <LinkedInRedirect />,
    },
    {
      path: 'pinterest-redirect',
      element: <PinterestRedirect />,
    },
    {
      path: 'google-redirect',
      element: <GoogleRedirect />,
    },
    {
      path: 'threads-redirect',
      element: <ThreadsRedirect />,
    },
    {
      path: 'tiktok-redirect',
      element: <TikTokRedirect />,
    },
    {
      path: 'instagram-redirect',
      element: <InstagramRedirect />,
    },
    {
      path: 'payment-redirect',
      element: <PaymentRedirect />,
    },
    {
      path: 'payment-failure',
      element: <PaymentFailureComponent />,
    },
    {
      path: 'payment-success',
      element: <PaymentSuccessComponent />,
    },
    {
      path: 'posts/:urlKey',
      element: <PublicApproval />,
    },
    {
      path: 'scheduled-report',
      element: <ScheduledReport />,
    },
    {
      path: 'custom-scheduled-report',
      element: <CustomScheduledReport />,
    },
    {
      path: 'on-boarding',
      element: <OnBoardingComponent />,
    },
    {
      path: 'payment-boarding',
      element: <PaymentOnBoardingComponent />,
    },
    {
      path: 'reseller-registration',
      element: <ResellerUserRegistrationComponent />,
    },
  ];
};

export const Routes = {
  PublicRoutes,
  PrivateRoute,
};
